function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function deprecationWarnings(className, props, deprecations) {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  var _iterator = _createForOfIteratorHelper(deprecations),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var deprecation = _step.value;
      var property = deprecation.property,
        _deprecation$type = deprecation.type,
        type = _deprecation$type === void 0 ? 'enabled by default' : _deprecation$type,
        _deprecation$descript = deprecation.description,
        description = _deprecation$descript === void 0 ? '' : _deprecation$descript,
        _deprecation$conditio = deprecation.condition,
        condition = _deprecation$conditio === void 0 ? function () {
          return true;
        } : _deprecation$conditio;
      if (props.hasOwnProperty(property)) {
        if (condition(props)) {
          // eslint-disable-next-line no-console
          console.warn("".concat(property, " property for ").concat(className, " is deprecated. ").concat(description, " [Will be ").concat(type, " in the next major editor-core version]"));
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
export default deprecationWarnings;